export default __webpack_public_path__ + "static/media/google_download.971a9024.svg";